export enum LocalStorageKeys {
  DISPLAY_PAGE_SETTINGS = 'display_page_settings',
  TRANSACTION_COGS_AUTOSAVE = 'transaction_cogs_autosave',
}
